import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { JsonToExcel } from 'react-json-to-excel';
import { getEmailPart, getNamePart } from 'utils/StringUtils';

export const ExcelExportButton = (props) => {
  const { t } = useTranslation();
  const [netlinkingExcelData, setNetlinkingExcelData] = useState(null);
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  function handleLanguageId(value) {
    let result;

    switch (value) {
      case 6:
        result = 'Fr';
        break;
      case 1:
        result = 'En';
        break;
      case 2:
        result = 'De';
        break;
      case 3:
        result = 'Es';
        break;
      case 4:
        result = 'It';
        break;
      case 5:
        result = 'Pt';
        break;
      default:
        result = 'Fr';
        break;
    }

    return result;
  }

  function getFeedbackByRole(feedbacksList, role) {
    if (!feedbacksList || feedbacksList.length === 0) return '';
    return feedbacksList
      .filter(
        (fb) => (fb.authorRole ?? '').replace(/^ROLE_/, '').toUpperCase() === role
      )
      .map((fb) => fb.comment)
      .join(' | ');
  }
  const handleClick = async () => {
    const dataToExport =
      props.netlinkingExportList.length > 0
        ? props.netlinkingExportList
        : props.netlinkingFilteredListData.length > 0
          ? props.netlinkingFilteredListData
          : props.netlinkingData;
    const tmpExcelData = dataToExport.map((netlinkingData) => ({
      [t('Domaine')]: netlinkingData.domain,
      [t('Domaine Simple')]: netlinkingData.domain
        .replace('https://', '')
        .replace('http://', '')
        .replace('www.', ''),
      [t('Langue')]: handleLanguageId(netlinkingData.languageId),
      [t('Commentaire client')]: getFeedbackByRole(netlinkingData.feedbacksList, 'CLIENT'),
      [t('Commentaire super consultant')]: getFeedbackByRole(netlinkingData.feedbacksList, 'SUPER_CONSULTANT'),
      [t('Thématique')]: netlinkingData.themesList,
      [t('Topic Majestic')]: netlinkingData.topicsList,
      [t('Kw positionés')]: netlinkingData.kwPositioned,
      [t('Trafic')]: netlinkingData.trafic,
      [t('TF')]: netlinkingData.tF,
      [t('CF')]: netlinkingData.cF,
      [`${t('Tarif')} ` + ' HR']: netlinkingData.tarifHr,
      [`${t('Tarif')} ` + ' RC']: netlinkingData.tarifRc,
      [t('Tarif plateforme') + ' HR']: netlinkingData?.platformHR,
      [t('Tarif plateforme') + ' RC']: netlinkingData?.platformRC,
      [t('Nom platforme')]: netlinkingData.platformName,
      [t('Condition')]: netlinkingData.conditions,
      [t('Contact')]: getEmailPart(netlinkingData.contact),
      [t('Nom contact')]: getNamePart(netlinkingData.contact),
      [t('Téléphone')]: netlinkingData.contactPhoneNumber,
    }));
    setNetlinkingExcelData(tmpExcelData);
    await sleep(500);
    document.querySelector('.download-button').click();
  };

  return (
    <div className="container-excel img-container">
      <div className={props.netlinkingExportList.length > 0 ? 'icon-btn-test' : ''}>
        <div className="">
          <img
            src="/Images/icon-excel.png"
            onClick={handleClick}
            className="App-logo-excel"
            alt="logo"
          />
        </div>
      </div>
      <div className="json-to-excel-container">
        <JsonToExcel
          data={netlinkingExcelData}
          fileName="netlinking-report"
          fields={[
            { label: 'domain', value: 'domain' },
            { label: 'cleanDomain', value: 'cleanDomain' },
            { label: 'language', value: 'language' },
            { label: 'themesList', value: 'themesList' },
            { label: 'topicsList', value: 'topicsList' },
            { label: 'kwPositioned', value: 'kwPositioned' },
            { label: 'trafic', value: 'trafic' },
            { label: 'tF', value: 'tF' },
            { label: 'cF', value: 'cF' },
            { label: 'tarifHr', value: 'tarifHr' },
            { label: 'tarifRc', value: 'tarifRc' },
            { label: 'conditions', value: 'conditions' },
            { label: 'contactedTime', value: 'contactedTime' },
            { label: 'contact', value: 'contact' },
          ]}
          buttonText="Export to Excel"
          btnColor="white"
          btnClassName="download-button"
        />
      </div>
    </div>
  );
};
